
export default {
  props: {
    url: {
      type: String,
      required: true
    },

    align: {
      type: String,
      default: 'top'
    }
  },
  computed: {
    isApple () {
      return this.$device.isMacOS || this.$device.isIos;
    },

    cleanedUrl () {
      return this.url.replace(/^https?:\/\//, '');
    },

    googleUrl () {
      return `https://calendar.google.com/calendar/render?cid=${encodeURIComponent(
        'webcal://' + this.cleanedUrl
      )}`;
    }
  }
};
